/* Bedtextielonline (Claude): euroteken bij prijzen die door onze eigen scripts worden ingevuld
   (bv. 'Maak je bed compleet' na een maat- of kleurwissel). Doet alleen iets als het geldformaat van de winkel een € bevat,
   zodat alle prijzen er dan hetzelfde uitzien als de prijzen uit Shopify zelf. */
(function () {
  var s = window.themeVariables && window.themeVariables.settings;
  var f = (s && s.moneyFormat) || '';
  if (f.indexOf('€') < 0 && f.indexOf('&euro;') < 0) return;
  var voor = f.split('{{')[0].replace('&euro;', '€');
  var PRIJS = /^\s*\d{1,3}(\.\d{3})*,\d\d\s*$/;
  var bezig = false;
  function zet(root) {
    if (bezig) return;
    bezig = true;
    var w = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      if (!PRIJS.test(n.nodeValue)) continue;
      var p = n.parentNode;
      if (!p || /^(SCRIPT|STYLE|OPTION|TEXTAREA)$/.test(p.nodeName)) continue;
      if (p.closest && p.closest('[data-btol-geen-euro]')) continue;
      n.nodeValue = voor + n.nodeValue.trim();
    }
    bezig = false;
  }
  var wacht = null;
  function straks() { clearTimeout(wacht); wacht = setTimeout(function () { zet(); }, 30); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { zet(); }); else zet();
  if (window.MutationObserver) new MutationObserver(function () { if (!bezig) straks(); }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();

/* Bedtextielonline (Claude): maak je de winkelwagen leeg terwijl je naar beneden gescrold was,
   dan springt de lade terug naar boven, zodat je 'Je winkelwagen is nog leeg' meteen ziet. */
(function () {
  var vorige = null;
  function kijk() {
    var d = document.querySelector('cart-drawer');
    if (!d || !d.shadowRoot) return;
    var leeg = !!d.querySelector('.btol-leeg');
    if (leeg && vorige === false) {
      var b = d.shadowRoot.querySelector('[part~="body"]');
      if (b) b.scrollTop = 0;
    }
    vorige = leeg;
  }
  function start() {
    var d = document.querySelector('cart-drawer');
    if (!d || !window.MutationObserver) return;
    kijk();
    new MutationObserver(kijk).observe(d, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();